import { DatePickerInput } from "@mantine/dates"
import { useTranslation } from "react-i18next"
import { useQueryState } from "@/hooks"
import { dayjs } from "@/utils"

const filterName = "daterange"

type DateRangeValue = [Date | null, Date | null]

function toDefaultValue(value?: string[]): DateRangeValue {
  if (value?.length !== 2) return [null, null]
  return [dayjs(value[0]!).toDate(), dayjs(value[1]!).toDate()]
}

export function DateRangeFilter({ defaultRange }: { defaultRange?: string[] }) {
  const { t } = useTranslation()
  const [queryValue, setQueryValue] = useQueryState<string[]>(filterName, { multi: true })
  const value = queryValue?.length === 2 ? queryValue : defaultRange

  return (
    <DatePickerInput
      miw={150}
      type="range"
      size="xs"
      clearable
      numberOfColumns={2}
      valueFormat="D MMM YYYY"
      placeholder={t("Filter by date")}
      key={value?.join("|") ?? "empty"}
      defaultValue={toDefaultValue(value)}
      onChange={(dates) => {
        const [from, to] = dates ?? [null, null]
        if (!from && !to) {
          setQueryValue(undefined)
          return
        }
        if (from && to) {
          setQueryValue([dayjs(from).format("YYYY-MM-DD"), dayjs(to).format("YYYY-MM-DD")])
        }
      }}
      popoverProps={{ withinPortal: true }}
    />
  )
}

DateRangeFilter.useValue = () => {
  const [value] = useQueryState<string[]>(filterName, { multi: true })
  return value ?? []
}
